module.exports = __webpack_public_path__ + "static/media/icon.ac47edd4.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Images/icon.svg
 ** module id = 355
 ** module chunks = 0
 **/